// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorView_content__3Y0Lw","text":"ErrorView_text__3mf-d","button":"ErrorView_button__16cCJ"};